import React, {useEffect} from 'react'
import {OverlayTrigger, Row, Tooltip} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useSelector} from 'react-redux'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {PartysListFilter} from './PartiesListFilter'
import { useNavigate } from 'react-router-dom'
import { Dispatch, SetStateAction } from 'react';

interface PartiesListToolbarProps {
  showParty: boolean;
  setShowParty: Dispatch<SetStateAction<boolean>>;
}
const PartysListToolbar: React.FC<PartiesListToolbarProps> = ({ showParty, setShowParty }) => {
  const {setItemIdForUpdate} = useListView()
  const {state}: any = useQueryRequest()
  const moduleName = useSelector((state: any) => state.shortCut.module_name)
  const cityList = useSelector((state: any) => state.commonList.cityList)

 const navigate = useNavigate()
  useEffect(() => {
    if (moduleName === 'partyActive') {
      setItemIdForUpdate(null)
    }
  }, [moduleName, setItemIdForUpdate])
 const handleToggleBalance = () => {
    setShowParty((prev) => !prev); // Toggle state
    // Optional: Add logic to update context, Redux, or API if needed
    // Example: dispatch({ type: 'TOGGLE_BALANCE', payload: !showParty });
  };
  return (
    <>
      <Row>
        <div className='card mx-3 mx-md-0 px-sm-8 ilead__card'>
          <div className='d-flex justify-content-start align-items-center d-sm-block d-none'>
            <div className='d-flex align-items-center'>


            </div>
            <div className='d-flex align-items-center'>
              <PartysListFilter />
              {/* Back Button */}
              
             
              {/* Filter Button (from separate component) */}
              
              {/* Add Party Button */}
              <button
                type='button'
                className='btn btn-success ms-2'
                onClick={() => navigate('/partys/add-party')}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                Add Party
              </button>
              <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>{showParty ? 'Redirect Off' : 'Redirect On'}</Tooltip>}
          >
            <div className="form-check form-switch ms-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="showBalanceSwitch"
                checked={showParty}
                onChange={handleToggleBalance}
                style={{ cursor: 'pointer' }}
              />
              {/* <label className="form-check-label" htmlFor="showBalanceSwitch">
                {showParty ? 'Balance On' : 'Balance Off'}
              </label> */}
            </div>
          </OverlayTrigger>
              <div
                className="btn btn-icon btn-shadow-lg bg-primary text-white d-flex align-items-center justify-content-center border border-light me-2"
                style={{ width: "34px", height: "32px" }}
                role="button"
                aria-label="Go back to previous page"
                tabIndex={0}
                data-tooltip="Back"
                onClick={() => navigate(-1)}
              >
                <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
              </div>
            </div>
          </div>
        </div>
      </Row>
    </>
  )
}

export {PartysListToolbar}
